import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  APPLICATION_CONFIGURATION_API,
  LANGUAGE_API,
} from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { LanguageClientModel, LocalizationState } from "./localization.models";

export const fetchLocalization = createAsyncThunk(
  "localization/fetchLocalization",
  async () => {
    const res = await apiClient.getHttp(
      APPLICATION_CONFIGURATION_API,
      undefined,
      false
    );
    return {
      resource: res.data.localization.values,
      supporLanguages: res.data.localization.languages,
    } as LocalizationState;
  }
);

export const fetchClientLanguages = createAsyncThunk(
  "localization/fetchClientLanguages",
  async () => {
    const res = await apiClient.getHttp<LanguageClientModel[]>(
      LANGUAGE_API,
      undefined,
      false
    );
    return res.data;
  }
);

const initialState: LocalizationState = {
  resource: {},
  supporLanguages: [],
  clientLanguages: [],
};

export const localizationSlice = createSlice({
  name: "localization",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchLocalization.fulfilled, (state, action) => {
      state.resource = action.payload.resource;
      state.supporLanguages = action.payload.supporLanguages;
    });
    builder.addCase(fetchClientLanguages.fulfilled, (state, action) => {
      state.clientLanguages = action.payload;
    });
  },
});
